module.exports = __webpack_public_path__ + "static/cover-bd89f589358df3cbaa024ef17d2e8682.jpg";